var _rect, _rect2, _g, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoasProjectionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 46,
    height: 46,
    rx: 12,
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 11.5,
    stroke: "url(#paint0_linear_6310_206477)",
    strokeOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6310_206477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8595 33.9843C13.0229 33.9631 12.3893 33.4599 12.3209 32.6259C12.2799 32.1264 12.25 31.4398 12.25 30.5C12.25 29.5602 12.2799 28.8736 12.3209 28.3741C12.3893 27.5401 13.0229 27.0369 13.8595 27.0157C14.2255 27.0064 14.6831 27 15.25 27C15.8169 27 16.2745 27.0064 16.6406 27.0157C17.4771 27.0369 18.1107 27.5401 18.1791 28.3741C18.22 28.8736 18.25 29.5602 18.25 30.5C18.25 31.4398 18.22 32.1264 18.1791 32.6259C18.1107 33.4599 17.4771 33.9631 16.6406 33.9843C16.2745 33.9936 15.8169 34 15.25 34C14.6831 34 14.2255 33.9936 13.8595 33.9843Z",
    fill: "#9AD6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0955 33.9792C29.1209 33.9408 28.4375 33.2557 28.3743 32.2823C28.3088 31.2731 28.25 29.6337 28.25 27C28.25 24.3663 28.3088 22.727 28.3743 21.7177C28.4375 20.7444 29.1209 20.0592 30.0955 20.0208C30.4171 20.0081 30.799 20 31.25 20C31.701 20 32.0829 20.0081 32.4045 20.0208C33.3791 20.0592 34.0625 20.7444 34.1257 21.7177C34.1912 22.727 34.25 24.3663 34.25 27C34.25 29.6337 34.1912 31.2731 34.1257 32.2823C34.0625 33.2557 33.3791 33.9408 32.4045 33.9792C32.0829 33.992 31.701 34 31.25 34C30.799 34 30.4171 33.992 30.0955 33.9792Z",
    fill: "#9AD6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0266 33.9832C21.0927 33.9548 20.412 33.3419 20.3449 32.41C20.2922 31.6775 20.25 30.5936 20.25 29C20.25 27.4064 20.2922 26.3225 20.3449 25.59C20.412 24.6581 21.0927 24.0453 22.0266 24.0169C22.3622 24.0067 22.7663 24 23.25 24C23.7337 24 24.1378 24.0067 24.4734 24.0169C25.4073 24.0453 26.088 24.6581 26.1551 25.59C26.2078 26.3225 26.25 27.4064 26.25 29C26.25 30.5936 26.2078 31.6775 26.1551 32.41C26.088 33.3419 25.4073 33.9548 24.4734 33.9832C24.1378 33.9934 23.7337 34 23.25 34C22.7663 34 22.3622 33.9934 22.0266 33.9832Z",
    fill: "#9AD6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2103 17.0506C32.1606 18.0386 31.2209 18.4098 30.492 17.741C30.1606 17.4369 29.7638 17.0626 29.2918 16.6029C28.2256 17.5731 26.572 19.0859 24.6006 20.9165C24.0829 21.3972 23.242 21.3435 22.7897 20.8007L22.7894 20.8003C21.9018 19.7384 21.0076 18.6807 20.0822 17.6514C19.0009 18.4453 17.06 19.9583 15.1339 21.8844C14.6457 22.3725 13.8543 22.3725 13.3661 21.8844C12.878 21.3962 12.878 20.6048 13.3661 20.1166C15.2557 18.227 17.329 16.4545 19.5526 14.9631L19.556 14.9608C19.5569 14.9603 19.5566 14.9604 19.5566 14.9604C20.0524 14.6299 20.7126 14.6953 21.1339 15.1166C22.1019 16.0846 22.9765 17.1493 23.8618 18.1927C25.3669 16.8007 26.6348 15.6409 27.524 14.8314C27.1205 14.4151 26.7862 14.0601 26.51 13.759C25.841 13.03 26.2124 12.09 27.2006 12.0403C28.4615 11.9768 29.7555 11.9395 31.0011 12.1723C31.5619 12.2772 31.9733 12.6886 32.0781 13.2495C32.311 14.4952 32.2738 15.7895 32.2103 17.0506Z",
    fill: "#9AD6D1"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 4.35,
    width: 37.3,
    height: 37.3,
    rx: 7.65,
    stroke: "url(#paint1_linear_6310_206477)",
    strokeOpacity: 0.4,
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6310_206477",
    x: -0.750001,
    y: -1,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.890196 0 0 0 0 0.866667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-lighter",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6310_206477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6310_206477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6310_206477",
    x1: 60.4881,
    y1: 72.8333,
    x2: 19.5162,
    y2: 0.00000226996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDDAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EBFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6310_206477",
    x1: 21.35,
    y1: 42,
    x2: 21.825,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDDAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EBFF",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoasProjectionsIcon);
export default __webpack_public_path__ + "static/media/roas-projections-icon.0004341b518f7350a8c4837ee597fc00.svg";
export { ForwardRef as ReactComponent };